<template>
    <span :class="['team-badge', logoSrc?'has-logo':'']" :style="badgeStyle" :title="name" aria-hidden="true">
        <img v-if="logoSrc" :src="logoSrc" :alt="name + '队徽'">
        <span v-else>{{shortName}}</span>
    </span>
</template>

<script>
import {findTeamLogo} from '../../assets/team-logos'
export default {
    name: 'TeamBadge',
    props: {
        name: {type: String, default: ''},
        size: {type: Number, default: 30}
    },
    computed: {
        logoSrc(){ return findTeamLogo(this.name) },
        shortName(){
            const clean = (this.name || '球队').replace(/[\s()（）·.-]/g, '')
            return clean.slice(0, 1).toUpperCase()
        },
        badgeStyle(){
            const palettes = [
                ['#00d7ff', '#0876ff'], ['#65f5b5', '#00a97a'], ['#a8ff60', '#38a947'],
                ['#8f9dff', '#5457e8'], ['#ffb95e', '#ee6d30'], ['#4ee9d5', '#087f91']
            ]
            let hash = 0
            for(let i = 0; i < (this.name || '').length; i++) hash = ((hash << 5) - hash) + this.name.charCodeAt(i)
            const colors = palettes[Math.abs(hash) % palettes.length]
            return this.logoSrc ? {
                width: this.size + 'px', height: this.size + 'px'
            } : {
                width: this.size + 'px', height: this.size + 'px',
                background: 'linear-gradient(145deg,' + colors[0] + ',' + colors[1] + ')'
            }
        }
    }
}
</script>

<style scoped>
.team-badge{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;border-radius:50% 50% 44% 44%;color:#061522;font-size:12px;font-weight:900;border:2px solid rgba(255,255,255,.72);box-shadow:0 0 0 2px rgba(0,215,255,.14),0 5px 14px rgba(0,0,0,.28);position:relative;overflow:hidden}
.team-badge:before{content:"";position:absolute;inset:3px;border:1px solid rgba(5,22,34,.38);border-radius:50%}
.team-badge:after{content:"";position:absolute;width:55%;height:2px;background:rgba(5,22,34,.35);transform:rotate(-35deg)}
.team-badge span{position:relative;z-index:1;text-shadow:0 1px rgba(255,255,255,.35)}
.team-badge.has-logo{background:rgba(255,255,255,.96);padding:3px;border-color:rgba(93,225,255,.72)}
.team-badge.has-logo:before,.team-badge.has-logo:after{display:none}
.team-badge img{display:block;width:100%;height:100%;object-fit:contain;position:relative;z-index:1}
</style>
